import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { GlobalContants, Resource } from 'src/app/constants/global.contants';
import { environment } from 'src/environments/environment';
import { ApiTitleComponent } from '../../common/api-title/api-title.component';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';
import { ApiUIResponseComponent } from '../api-ui-response/api-ui-response.component';
import { HTTPMethod } from 'src/app/constants/enum';
import { apiEndPoints } from 'src/app/constants/api-endpointsconstant';

export interface statusCode {
  key: string;
  value: string;
  required: boolean
}

const Headers: statusCode[] = [
  {
    key : "Content-Type",
    value: 'application/json',
    required: false
  },
  {
    key : "API-KEY",
    value: '{{API-KEY}}',
    required: true
  },
  {
    key : "USER-TOKEN",
    value: '{{USER-TOKEN}}',
    required: true
  },
];
const QueryData :any =[
  {
    param : "lat",
    value: '{{lat}}',
    required: true
  },
  {
    param : "lon",
    value: '{{lon}}',
    required: true
  },
  {
    param : "land_area (in sqm)",
    value: '{{land_area}}',
    required: false
  },
]

@Component({
  selector: 'app-commercial-data',
  standalone: true,
  imports: [CommonModule, MaterialModule, RouterModule, ApiTitleComponent, ApiUIResponseComponent],
  templateUrl: './commercial-data.component.html'
})
export class CommercialDataComponent {

  HTTPMethod = HTTPMethod;
  displayedColumns: string[] = ['key', 'value', 'required'];
  QueryColumns: string[] = ['param', 'value', 'required'];
  dataSource = Headers;
  QueryDataSource = QueryData;

  api_ui: boolean = false;

  GlobalContants = GlobalContants
  constructor(private sharedService: SharedService, 
      private userService: UserService, 
      private router: Router){
    
  }

  ngOnInit() {
    let userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
        this.userService.getAllUserResource(userInfo.user_id)
          .subscribe({
            next: (res: any) => {
              const matched = res.data.find((r: any) => r.resource_name === Resource.OfficeProperty);
                if (!matched?.methods?.includes(HTTPMethod.GET)) {
                 this.router.navigate(['/'])
                }
            },
            error: (err) => {
            }
          })
   }

  ngAfterViewInit(){
   
  }

  api_demo= `${environment.apiBaseUrl}${apiEndPoints.officeProperty}`;

  api_response = `{
  "status": 0,
  "message": "string",
  "data": {
    "property_uid": "string",
    "land_value_lower_range": 0,
    "land_value_midpoint": 0,
    "land_value_higher_range": 0,
    "built_value_lower_range": 0,
    "built_value_mid_range": 0,
    "built_value_higher_range": 0,
    "property_build_year": "string",
    "property_age": "string",
    "property_name": "string",
    "property_grade": "string",
    "property_category": "string",
    "total_gla": 0,
    "office_gla": 0,
    "retail_gla": 0,
    "office_rental_0_50": 0,
    "office_rental_50_100": 0,
    "office_rental_100_200": 0,
    "office_rental_200_300": 0,
    "office_rental_300_500": 0,
    "office_rental_500_750": 0,
    "office_rental_750_1000": 0,
    "office_rental_1000+": 0,
    "retail_rental_0_20": 0,
    "retail_rental_20_50": 0,
    "retail_rental_50_100": 0,
    "retail_rental_100_200": 0,
    "retail_rental_200_500": 0,
    "retail_rental_500_1000": 0,
    "retail_rental_1000_3000": 0,
    "retail_rental_3000+": 0,
    "name_of_highway": "string",
    "record_type_government": "string",
    "record_type_estater": "string",
    "value": 0,
    "transaction_area": 0,
    "transaction_area_rate": 0,
    "transaction_date": "string"
  }
}`;


}
